'use client';
import e from 'prop-types';
import { createComponent } from '../core/create-component.js';
import { SWAN_STYLE_KEY_MAP } from '../head/stylesheets.component.js';

let n = {
    xs: e.bool,
    sm: e.bool,
    md: e.bool,
    lg: e.bool,
    xl: e.bool
};
const Hidden = createComponent({
    displayName: 'Hidden',
    root: 'div',
    propTypes: n,
    requiredStyleKeys: SWAN_STYLE_KEY_MAP.hidden,
    propConfig: {
        classNames (d) {
            let o = new Set(), { xs: e = !1, sm: n = !1, md: s = !1, lg: a = !1, xl: r = !1 } = d;
            return e && o.add('swan-hidden-xs'), n && o.add('swan-hidden-sm'), s && o.add('swan-hidden-md'), a && o.add('swan-hidden-lg'), r && o.add('swan-hidden-xl'), o;
        }
    }
});

export { Hidden };
